/** Spanish perimeter-and-area prompts (ADR 0051 part 3). */
/** A no-break space (WinAnsi 0xA0), so a question mark is never left at the head of a line. */
const NO_BREAK = String.fromCharCode(0xa0);

export const shapePrompts = {
    // Shorter than "¿Cuál es el lado que falta?" on purpose - ADR 0051 §7
    // part 3's measurement found the longer phrasing pushed the Missing Side
    // question over the page at full 8 and half 3 (with answer keys), a
    // count that was already tight in English. See docs/plans/README.md.
    missingSide: (area: string) => `El área es ${area}. ¿Qué lado falta?`,
    perimeter: () => `¿Cuál es el perímetro?`,
    area: () => `¿Cuál es el área?`,
    // Scale Drawing (ADR 0107).
    scaleLine: (scale: string) => `Escala: ${scale}`,
    actualSize: () => `¿Cuáles son el largo y el ancho reales?`,
    actualArea: () => `¿Cuál es el área real?`,
    drawingLength: (actual: string) => `El lado marcado con${NO_BREAK}? mide ${actual} en la realidad. ¿Cuánto mide en el dibujo?`,
    anotherScale: (scale: string) => `Se redibuja con una escala de ${scale}. ¿Cuáles son las nuevas dimensiones?`,
    /** "24 m por 16 m". */
    bySize: (length: string, width: string) => `${length} por ${width}`,
};
